import { globalData } from "../..";
import { processGender } from "../../env";

const createText = ({ contentDiv, text }) => {

    if (text.includes('{pname}')) {

        const reg = new RegExp(`{pname}`, 'g')
        const name = processGender()?.name;
        const { pname } = globalData;

        //REPLACE PNAME WITH NAME OR MODEL NAME IF IT EXISTS
        if (displayType === 'random' && name) {
            text = text.replace(reg, name)
        } else if (pname) {
            text = text.replace(reg, pname)
        }
    }

    contentDiv.innerHTML = text;
}

export { createText }